module.exports = __webpack_public_path__ + "static/RemoteMediaFile_6553661_0_2021_09_22_13_58_30-1500x843-be5e2041d2692d36dc0872711d8218a9.jpg";